import React from 'react';
import rightArrowIcon from './rightArrow_icon.svg';
import documentIcon from './document_icon.svg';
import styles from './TemplateGroup.module.scss';
import cn from 'classnames';

const TemplateGroup = ({
 templateGroup, templateNum, onSelect, changeButtonText,
}: IProps) => (
    <section className={cn(styles.document, onSelect === undefined && styles.document_disabled)}>
        <span className={styles.document_title}>Вариант {templateNum}</span>
        {templateGroup.map((template, j) => (
            <div key={`template_${templateNum}_${j}`} className={styles.document_row}>
                <img className={styles.document_icon} src={documentIcon} alt="documentIcon" />
                <span className={styles.document_text}>{template.description}</span>
            </div>
        ))}

        <span
          className={cn(styles.document_button, onSelect === undefined && styles.document_button_hide)}
          onClick={onSelect}
        >
            {changeButtonText || 'Перейти к загрузке документов'} <img src={rightArrowIcon} alt="rightArrowIcon" />
        </span>
    </section>
);

export default TemplateGroup;

interface IProps {
    templateGroup: ITemplate[];
    templateNum: number;
    changeButtonText?: string;
    onSelect?: () => void;
}

interface ITemplate {
    id: string;
    order: number;
    variant: number;
    description: string;
}
